import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';

import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { trackByValue } from '@recruitee/common';

import {
  BreadcrumbItem,
  IMainViewState,
  MainViewState,
} from '../../../core/state/main-view/main-view.state';

@Component({
  selector: 'rtr-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.less'],
})
export class BreadcrumbsComponent {
  public breadcrumbs: BreadcrumbItem[];
  public trackByValue: Function = trackByValue;

  @Select(MainViewState)
  public mainViewState$: Observable<IMainViewState>;
  private ngOnDestroy$: Subject<void> = new Subject();

  constructor(private cdRef: ChangeDetectorRef, private store: Store, private router: Router) {}

  public ngOnInit(): void {
    this.mainViewState$
      .pipe(
        map(state => state.breadcrumbs),
        takeUntil(this.ngOnDestroy$),
      )
      .subscribe(breadcrumbs => {
        this.breadcrumbs = breadcrumbs;
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public navigate(url: string): void {
    this.router.navigate([url]);
  }
}
